//TODO, this is kinda of a redundant file, but I created it to help with the refactoring
//My hunch is that this will stay here for a while until the next time we do refactoring
const terms_and_conditions = []
export default terms_and_conditions